import { OperatorType } from '@adv-frontend/filters';
import { type OperatorValue } from './types';

export const OPERATOR_VALUES_MAP = Object.entries(OperatorType).reduce(
    (acc, [key, value]) => {
        acc[value] = key as keyof typeof OperatorType;

        return acc;
    },
    {} as Record<OperatorValue, keyof typeof OperatorType>
);
